<template>
  <div class="page-container">
    <div class="material-container">
      <div class="container-header">
        <h2>素材库-上传素材</h2>
      </div>
    </div>
    <div class="material-main">
      <div class="main-form">
        <el-form
          ref="material_form"
          label-width="100px"
          :label-position="'top'"
          :model="material_form"
        >
          <div
            v-for="(form_item, from_key) in material_form"
            :key="from_key"
            class="material-item"
            :style="{
              display: (form_item.type === 'select' || form_item.type === 'select-tree') ? 'inline-block' : 'block',
            }"
          >
            <el-form-item
              :label-width="'100px'"
              :label="form_item.label"
              :prop="from_key + '.value'"
              :rules="[
                { required: form_item.required, message: form_item.placeholder, trigger: ['blur', 'change']},
              ]"
            >
              <!-- 输入框 -->
              <el-input
                v-if="form_item.type === 'input'"
                v-model="form_item.value"
                :placeholder="form_item.placeholder"
                v-bind="form_item.props"
                v-on="form_item.on"
              />

              <!-- 多选框 -->
              <el-select
                v-if="form_item.type === 'select'"
                v-model="form_item.value"
                :placeholder="form_item.placeholder"
                v-bind="form_item.props"
                v-on="form_item.on"
              >
                <el-option
                  v-for="(item, index) in form_item.options"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>

              <!-- 选项树 -->
              <select-tree
                v-if="form_item.type === 'select-tree'"
                :value="form_item.value"
                v-bind="form_item.props"
                v-on="form_item.on"
              />

              <!-- 上传图片 -->
              <div>
                <el-upload
                  v-if="form_item.type === 'updata'"
                  ref="upload-material"
                  action="https://jsonplaceholder.typicode.com/posts/"
                  multiple
                  :auto-upload="false"
                  :limit="20"
                  :disabled="material_form.material_standard.value ? false : true"
                  :on-remove="handleFileRemove"
                  :on-exceed="handleFileExceed"
                  :on-change="handleFileChange"
                  :before-remove="beforeFileRemove"
                >

                  <el-button
                    :disabled="material_form.material_standard.value ? false : true"
                    size="small"
                    type="primary"
                  >点击上传</el-button>
                  <div v-if="material_form.material_standard.value" slot="tip" class="el-upload__tip">
                    <p v-if="restriction.type !== 3">宽高：{{ restriction.width }} * {{ restriction.height }}</p>
                    <p>只能上传{{ restriction.mime_type.join('/') }}文件，且不超过{{ (restriction.type === 2 ? restriction.max_size : max_size)/1024 }}M</p>
                  </div>
                </el-upload>
              </div>
            </el-form-item>
          </div>
          <div class="control-button">
            <el-button
              v-loading="is_loading"
              type="primary"
              @click="onSubmitForm"
            >
              上传
            </el-button>
            <el-button
              @click="onResetForm()"
            >
              重置
            </el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>

// 获取用户列表接口
import UserResource from '@/api/user';
const userResource = new UserResource();

// 获取游戏列表接口
import AdvertisingResource from '@/api/advertising';
const advertisingResource = new AdvertisingResource();

// 素材库上传
import MaterialResource from '@/api/material/index';
const materialResource = new MaterialResource();

// 素材规格列表接口
import MaterialFormatResource from '@/api/material/format';
const materialFormatResource = new MaterialFormatResource();

export default {
  components: {
    'select-tree': () => import('@/components/select-tree'),
  },
  data() {
    return {
      temp_value: '',
      // 素材规格列表参数
      material_format_list_params: {
        page: 1,
        limit: 10,
      },
      // 素材表单
      material_form: {
        author: {
          label: '作者',
          placeholder: '请输入作者',
          type: 'select',
          options: [],
          value: '',
          required: true,
          props: {
            disabled: true,
          },
        },
        demander: {
          label: '需求人',
          placeholder: '请输入需求人',
          type: 'select',
          options: [],
          value: '',
          required: true,
          props: {
            filterable: true,
          },
        },
        material_type: {
          label: '素材类型',
          placeholder: '请输入素材类型',
          type: 'select',
          options: [
            {
              label: '图片',
              value: 1,
            },
            {
              label: '视频',
              value: 2,
            },
            {
              label: '落地页',
              value: 3,
            },
            {
              label: '组图',
              value: 4,
            },
          ],
          value: '',
          required: true,
          on: {
            change: (val) => {
              this.material_format_list_params['type'] = val;
              this.getMaterialFormatList(this.material_format_list_params).then((res) => {
                this.material_format_list = res.list;
                this.material_form.material_standard.options = res.list.map((item) => {
                  return {
                    label: item.name,
                    value: item.id,
                  };
                });
                this.material_form.material_standard.value = null;
                this.material_form.updata_file.value = [];
                this.$refs['upload-material'][0].clearFiles();
              });
            },
          },
        },
        games: {
          label: '游戏',
          type: 'select-tree',
          placeholder: '请选择游戏',
          props: {
            options: [],
            ischeckbox: false,
            'check-on-click-node': true,
            props: {
              value: 'id',
              label: 'name',
              children: 'children',
            },
            'select-props': {
              placeholder: '请选择游戏',
              clearable: true,
              accordion: true,
            },
          },
          on: {
            getValue: (game_id) => {
              this.material_form.games.value = game_id;
            },
          },
          value: null,
          required: true,
        },
        material_standard: {
          label: '素材标准',
          placeholder: '请输入素材标准',
          type: 'select',
          options: [],
          value: null,
          required: true,
          props: {
            filterable: true,
          },
          on: {
            change: (val) => {
              this.restriction = this.material_format_list.filter((item) => {
                return item.id === val;
              })[0];
            },
          },
        },
        remarks: {
          label: '备注',
          placeholder: '请输入备注',
          type: 'input',
          value: '',
        },
        updata_file: {
          label: '上传素材',
          placeholder: '请上传素材',
          type: 'updata',
          value: [],
          required: true,
          rules: [
            {
              required: true, message: function(){
                return this.placeholder;
              }, trigger: 'change',
            },
          ],
        },
        material_format_list: [], // 规格列表
        restriction: {}, // 限制详情
      },
      is_loading: false,
      max_size: 3072,
    };
  },
  mounted() {
    this.initForm();
  },
  methods: {
    // 初始化表单
    initForm: function() {
      this.getUserListData({ page: 1, limit: -1 }).then((res) => {
        this.material_form.demander.options = res.data.map((item) => {
          return {
            label: item.name,
            value: item.id,
          };
        });
        this.material_form.author.options = this.material_form.demander.options;
        this.material_form.author.value = this.$store.getters.userId;
      });
      this.getGameList({ refresh: 1, is_parent: 1 }).then((res) => {
        this.material_form.games.props.options = res.list;
        this.material_form.games.value = null;
      });
    },
    // 提交表单
    onSubmitForm: function() {
      let is_submit = false;
      this.$refs['material_form'].validate((valid, form_rule_list) => {
        if (valid) {
          is_submit = true;
        } else {
          is_submit = false;
        }
      });

      if (is_submit) {
        const params = {
          author_id: this.material_form.author.value,
          demand_sider_id: this.material_form.demander.value,
          material_type: this.material_form.material_type.value,
          is_original: 1,
          game_id: this.material_form.games.value,
          material_format_id: this.material_form.material_standard.value,
          note: this.material_form.remarks.value,
          materials: this.material_form.updata_file.value.map((item) => {
            return item.raw;
          }),
        };
        const formData = new FormData();
        Object.keys(params).forEach((key) => {
          if (typeof params[key] === 'object') {
            for (const item_key in params[key]) {
              formData.append(key + '[' + item_key + ']', params[key][item_key]);
            }
          } else if (params[key]){
            formData.append(key, params[key]);
          }
        });
        this.updataMaterial(formData);
      }
    },
    // 素材标准懒加载
    materialStandardLoadmore: function() {
      this.material_format_list_params.page++;
      this.getMaterialFormatList(this.material_format_list_params).then((res) => {
        const res_options = res.list.map((item) => {
          return {
            label: item.name,
            value: item.id,
          };
        });
        this.material_form.material_standard.options = [...this.material_form.material_standard.options, ...res_options];
      });
    },
    // 上传素材
    updataMaterial: function(params) {
      this.is_loading = true;
      return new Promise((resolve, reject) => {
        materialResource
          .updataMaterialApi(params)
          .then(response => {
            this.is_loading = false;
            if (response.data && response.data.message) {
              this.$message(response.data.message);
            } else {
              this.$message({
                message: '上传成功！',
                type: 'success',
              });
              this.onResetForm();
            }
            resolve(response);
          })
          .catch(error => {
            this.is_loading = false;
            reject(error);
          });
      });
    },
    // 获取素材规格列表
    getMaterialFormatList: function(params) {
      return new Promise((resolve, reject) => {
        materialFormatResource
          .getMaterialFormatListApi(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 获取游戏列表
    getGameList: function(params) {
      return new Promise((resolve, reject) => {
        advertisingResource
          .getGameListApi(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 获取用户列表
    getUserListData: function(params) {
      return new Promise((resolve, reject) => {
        userResource
          .getUserList(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 重置表单
    onResetForm() {
      this.$router.push({
        path: '/auxiliary/auxiliary-material-library/material-upload',
        query: {
          t: Date.now(),
        },
      });
    },
    // 超过限制数量事件
    handleFileExceed(files, fileList) {
      this.$message.warning(`当前限制选择 20 个文件`);
    },
    // 文件变化事件
    handleFileChange(file, fileList) {
      const item = file;
      this.material_form.updata_file.value = fileList;

      const is_video = this.restriction.type === 2;
      const show_file = is_video ? document.createElement('video') : new Image();
      if (this.verify(item.raw)) {
        if (is_video) {
          item.type = 'video';
          show_file.addEventListener('loadedmetadata', () => {
            const temp_duration = show_file.duration * 1000;
            if (temp_duration <= this.restriction.min_millisecond || temp_duration >= this.restriction.max_millisecond) {
              this.$message.error('视频时长≥' + this.restriction.min_millisecond + 's，视频时长≤' + this.restriction.max_millisecond + 's');
              return;
            }
            if (!this.verifySize(show_file.videoWidth, show_file.videoHeight)) {
              deleFile();
              return;
            } else {
              this.file_arr = fileList;
            }
          });
        } else {
          item.type = 'image';
          show_file.onload = () => {
            if (!this.verifySize(show_file.width, show_file.height)) {
              deleFile();
              return;
            } else {
              this.file_arr = fileList;
            }
          };
        }
        show_file.src = URL.createObjectURL(item.raw);
      } else {
        deleFile();
        return;
      }
      function deleFile() {
        const index = fileList.indexOf(file);
        fileList.splice(index, 1);
      }
    },
    // 验证
    verify(file) {
      const is_type = !this.verifyType(file.type);
      const file_size = this.restriction.type === 2 ? this.restriction.max_size : this.max_size;
      const is_file_size = file.size / 1024 < file_size;
      let is_corre = true;

      if (!is_type) {
        is_corre = false;
        this.$message.error('上传文件只能是 ' + this.restriction.mime_type + ' 格式!');
      } else if (!is_file_size) {
        is_corre = false;
        this.$message.error(
          '上传文件大小不能超过 ' + file_size + 'kb!'
        );
      }

      return is_corre;
    },
    // 验证大小尺寸
    verifySize(width, height) {
      let is_size = false;
      const isWidth = this.restriction.width === 0 ? true : width === this.restriction.width;
      const isHeigth = this.restriction.height === 0 ? true : height === this.restriction.height;
      if (isWidth && isHeigth && isWidth === true && isHeigth === true) {
        is_size = true;
      }
      if (!is_size) {
        this.$message.error('上传文件尺寸大小不符合要求');
      }
      return is_size;
    },
    // 验证文件类型
    verifyType(type) {
      let is_err = true;
      const type_arr = this.restriction.mime_type.map((item) => {
        return this.restriction.type === 2 ? 'video/' + item : 'image/' + item;
      });
      for (var i = 0; i < type_arr.length; i++) {
        const temp_type = type_arr[i];
        if (temp_type === type) {
          is_err = false;
        }
      }
      return is_err;
    },
    // 删除文件之前
    beforeFileRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 删除之后
    handleFileRemove(file, fileList) {
      this.material_form.updata_file.value = fileList;
    },
  },
};
</script>

<style lang="scss" scoped>
$background_color: #eef0f3;
$padding: 20px;

.material-container {
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  .container-header {
    border-bottom: 1px solid #fff;
    height: 40px;
    padding: 10px $padding;
    background-color: $background_color;
    h2 {
      margin: 0;
    }
  }
  .container-main {
    margin-top: 10px;
    padding: $padding;
    background-color: $background_color;
  }
}
.material-main {
  padding: $padding;
  background-color: $background_color;
  margin-top: 20px;
  .main-form {
    background-color: #fff;
    .el-form {
      max-width: 770px;
      padding: 110px 20px;
      margin: 0 auto;
      .material-item {
        margin-left: 20px;
      }
      .control-button {
        text-align: right;
      }
    }
  }

}
</style>
